module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAOklEQVRIiWPky2X4z0BDwAIy+uMk2tjBn8fIwERL14PAqAWjFoxaMGrBqAWjFoxaMDgsoG2zhYGBAQDRTwYlaAdsGwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer2/c.png
// module id = WPeV
// module chunks = 1